const EmptyBytes = new Uint8Array();
const NullBytes = new Uint8Array([0]);
export {
  EmptyBytes,
  NullBytes
};
//# sourceMappingURL=bytes.js.map
